module.exports = __webpack_public_path__ + "img/8-osd.67183004.png";